<ion-item-group>
  <ion-item-divider>
    <ion-label>{{ 'Mobile.Connectivity' | translate }}</ion-label>
  </ion-item-divider>

  <ion-item (click)="onReload()" lines="none">
    <ion-label>{{ 'SagaMobile.Reload' | translate }}</ion-label>
    <ion-icon slot="end" name="sync-outline" color="primary"></ion-icon>
  </ion-item>
  <ion-item (click)="logout()" lines="none">
    <ion-label>{{ 'Mobile.Logout' | translate }}</ion-label>
    <ion-icon slot="end" name="log-out-outline" color="primary"></ion-icon>
  </ion-item>
</ion-item-group>
